import { render, staticRenderFns } from "./approval_dialog.vue?vue&type=template&id=0018789c&scoped=true"
import script from "./approval_dialog.vue?vue&type=script&lang=js"
export * from "./approval_dialog.vue?vue&type=script&lang=js"
import style0 from "./approval_dialog.vue?vue&type=style&index=0&id=0018789c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0018789c",
  null
  
)

export default component.exports